import { Accordion, Button, Col, Container, Dropdown, Row } from "react-bootstrap";
import DetailItem from "../DataItem";
import { useEffect, useState } from "react";
import { SampleService } from "../../../../Services/Sample.service";
import DonorDemographicsList from "./DonorDemographicsList";
const SpecialDonorRequestsAccordion = ({ hasSpecialRequests, preferredDonorIds, alternateDonorIds, sampleRequestDetails }) => {
    useEffect(() => {
        


    }, [sampleRequestDetails])

      const [raceList, setRaceList] = useState([]); // Store race options from API
    
      const getRaceOptions = async () => {
    
        const result = await SampleService.getRaceOptions();
        if (result.success) {
    
          console.log("race options retrived sucessfully");
          setRaceList(result.race_option);
    
          // Extract and set heritage types separately
          const single = result.race_option.find(option => option.type_id === 1);
          const dual = result.race_option.find(option => option.type_id === 2);
    
          console.log("single", single); console.log("dual", dual);
    
    
          // setSingleHeritage(single ? single.race_options.map(r => r.heritage_name) : []);
          // setDualHeritage(dual ? dual.race_options.map(r => r.heritage_name) : []);
      
        }
        else {
          console.log("failed while getting race options")
        }
      }
      useEffect(() => {
        getRaceOptions();
      }, [sampleRequestDetails])
    return (
        <>

            {/* <Accordion className="accordion-item" flush> */}
            <Accordion.Item eventKey="7">
                <Accordion.Header><b>Special Donor Requests</b></Accordion.Header>
                <Accordion.Body>

                    {hasSpecialRequests ? (
                        <div className="el-property-details-card-content">
                            <Row>
                                <Col md={12} className="mx-fit-content">
                                    <div className="flex-sec justify-content-between col-xxl-6">
                                        {/* Preferred Donor IDs */}
                                        {/* {preferredDonorIds && preferredDonorIds.length > 0 && ( */}
                                            <>
                                                {/* <div className="col-12">
                                                    <h3 className="mb-4">Selected Preferred Donor IDs</h3>
                                                </div> */}
                                                {/* {preferredDonorIds.map((donorId, index) => ( */}


                                                    <>
                                                        {/* <div className="el-flex-area mb-3 mb-lg-0" key={`preferred-${index}`}>
                                                            <div className="el-content-detail">
                                                                <p className="el-request-detail-profile-title">Donor ID</p>
                                                                <h4 className="el-request-detail-profile-name">
                                                                    <a href="#">{donorId}</a>
                                                                </h4>
                                                            </div>
                                                        </div> */}

                                                        {/* <DetailItem

                                                            title="Donor ID"
                                                            detail={donorId || '-'}
                                                        /> */}

                                                        {  (<div>
                                                            <p className="el-request-detail-profile-title">
                                                                Preferred donor ID:
                                                            </p>
                                                            <h4 className="el-request-detail-profile-name">
                                                            <div className="d-flex">
                                                                <div>
                                                                    {JSON.parse(sampleRequestDetails.special_donor_ids)?.map((donor, index) => (
                                                                        <p key={index}>{index + 1}. Donor ID: {donor}</p>
                                                                    ))}
                                                                </div>
                                                                <div className="ms-1">
                                                                    {JSON.parse(sampleRequestDetails.special_donor_ids)?.map((_, index) => (
                                                                        <p key={index}>{sampleRequestDetails.special_donor_ids_gender?.[index]}</p>
                                                                    ))}
                                                                </div>
                                                            </div>

                                                            
                                                                {JSON.parse(sampleRequestDetails.special_donor_gender)?.map((donor, index) => (<p>{(JSON.parse(sampleRequestDetails.special_donor_ids)?.length || 0)  + index + 1}.  Donor ID: {donor}, {JSON.parse(sampleRequestDetails.special_donor_gender)[index] === 'XX' ?
                                                                    `Female (${JSON.parse(sampleRequestDetails.special_donor_gender_quantity)[index]})` :
                                                                    `Male (${JSON.parse(sampleRequestDetails.special_donor_gender_quantity)[index]})`}  </p>))}
                                                            </h4>
                                                        </div>) }
                                                        
                                                        {/* {  (<div><p className="el-request-detail-profile-title">
                                                            Alternate Donor ID:
                                                        </p> <h4 className="el-request-detail-profile-name">
                                                            <div className="d-flex">
                                                                <div>
                                                                    {JSON.parse(sampleRequestDetails.alternate_donor_ids)?.map((donor, index) => (<p>{index + 1}. Donor ID: {donor}, </p>))}
                                                                </div>
                                                                <div className="ms-1">
                                                                    {JSON.parse(sampleRequestDetails.alternate_donor_ids)?.map((_, index) => (
                                                                        <p key={index}>{sampleRequestDetails.alternate_donor_donor_ids_gender?.[index]}</p>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                                {JSON.parse(sampleRequestDetails.alternate_donor_gender)?.map((donor, index) => (<p>{(JSON.parse(sampleRequestDetails.alternate_donor_ids)?.length || 0)  + index + 1}.  Donor ID: {donor}, {JSON.parse(sampleRequestDetails.alternate_donor_gender)[index] === 'XX' ?
                                                                    `Female (${JSON.parse(sampleRequestDetails.alternate_donor_gender_quantity)[index]})` :
                                                                    `Male (${JSON.parse(sampleRequestDetails.alternate_donor_gender_quantity)[index]})`}  </p>))}
                                                            </h4></div>)} */}
                                                        {  (<div>
                                                            <DonorDemographicsList
                                                            sampleRequestDemographics={sampleRequestDetails.sample_request_demographics}
                                                            raceList={raceList}
                                                            />
                                                            {/* <p className="el-request-detail-profile-title">
                                                                Donor Groups by Demographics:
                                                            </p>

                                                            <div className="el-request-detail-profile-name">
                                                                <div className="d-flex flex-column gap-2">
                                                                    {sampleRequestDetails.sample_request_demographics?.map((item, index) => {
                                                                    const raceIds = item.race_options ? JSON.parse(item.race_options) : [];
                                                                    const allRaceList = raceList.flatMap(group => group.race_options);

                                                                    const raceNames =
                                                                        raceIds.length > 0
                                                                        ? allRaceList
                                                                            .filter(r => raceIds.includes(r.race_id))
                                                                            .map(r => r.heritage_name)
                                                                            .join(', ')
                                                                        : '';

                                                                    const serial = String.fromCharCode(97 + index); // 97 = 'a'

                                                                    // Build parts dynamically
                                                                    const parts = [];
                                                                    if (item.demographics_quantity) parts.push(item.demographics_quantity);
                                                                    if (item.from_age && item.to_age) parts.push(`${item.from_age}-${item.to_age}`);
                                                                    if (item.demographics_gender) {
                                                                        const genderText = item.demographics_gender === 'XX' ? 'Female' : 'Male';
                                                                        parts.push(`${genderText} (${item.demographics_gender})`);
                                                                    }
                                                                    if (raceNames) parts.push(raceNames);

                                                                    return (
                                                                        <div key={item.id} className="d-flex gap-2">
                                                                        <span>{serial}.</span>
                                                                        <span>{parts.join(', ')}</span>
                                                                        </div>
                                                                    );
                                                                    })}
                                                                </div>
                                                            </div> */}
                                                            </div>
                                                            )}

                                                    </>
                                                {/* ))} */}
                                            </>
                                        {/* )} */}

                                        {/* Alternate Donor IDs */}
                                        {alternateDonorIds && alternateDonorIds.length > 0 && (
                                            <>
                                                <div className="col-12">
                                                    <h3 className="my-4">Selected Alternate Donor IDs</h3>
                                                </div>
                                                {alternateDonorIds.map((donorId, index) => (
                                                    // <div className="el-flex-area mb-3 mb-lg-0" key={`alternate-${index}`}>
                                                    //     <div className="el-content-detail">
                                                    //         <p className="el-request-detail-profile-title">Donor ID</p>
                                                    //         <h4 className="el-request-detail-profile-name">
                                                    //             <a href="#">{donorId}</a>
                                                    //         </h4>
                                                    //     </div>
                                                    // </div>
                                                    <DetailItem
                                                        title="Donor ID"
                                                        detail={donorId || '-'}
                                                    />
                                                ))}
                                            </>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    ) : (
                        <p className="text-danger">No special donor requests available.</p>
                    )}
                </Accordion.Body>
            </Accordion.Item>
            {/* </Accordion> */}

        </>
    );
};


export default SpecialDonorRequestsAccordion